if(document.body.classList.contains('neos-backend')){
	document.addEventListener('keyup', function(e) {
		if(e.target.closest('.js-button')){
			triggerSameWidth(true);
		}
	});
	document.addEventListener('resize', function(event) {
		triggerSameWidth(true);
	}, true);
	triggerSameWidth(true);
} else {
	triggerSameWidth(false);
}


function triggerSameWidth(isBackend = false) {
	document.querySelectorAll('.js-buttons-equal-width').forEach((list) => {
		let biggestElementW = '0';
		list.style.setProperty('display', 'block');
		list.querySelectorAll('.js-button').forEach((button) => {
			if (isBackend) {
				button.style.setProperty('width', 'auto');
				button.style.setProperty('overflow', 'visible');
				button.style.setProperty('text-overflow', 'initial');
			}
			if (button.offsetWidth > biggestElementW) {
				biggestElementW = button.offsetWidth;
			}
			button.style.setProperty('width', biggestElementW + 2 + 'px');
		});
		list.style.setProperty('display', 'flex');
		list.querySelectorAll('.js-button').forEach((button) => {
				button.style.setProperty('width', biggestElementW + 2 + 'px');
			}
		);
	});
}
